export default __webpack_public_path__ + "static/media/safari.3245b7a0.png";